module.exports = __webpack_public_path__ + "static/share-ios@2x-304c3bddd2e461dd007c9f70dbb47ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/share/share-ios@2x.png
// module id = 926
// module chunks = 37722542382512 271422636699454